module.exports = __webpack_public_path__ + "static/img/bonus_6.c30d71f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lhzb/bonus_6.png
// module id = 0tm2
// module chunks = 0